/**
 * All font awesome icons
 */

export const FONT_AWESOME = [
    'abacus',
    'industry-alt',
    'ad',
    'industry',
    'address-book',
    'infinity',
    'address-card',
    'info-circle',
    'adjust',
    'info-square',
    'air-freshener',
    'info',
    'alarm-clock',
    'inhaler',
    'align-center',
    'integral',
    'align-justify',
    'intersection',
    'align-left',
    'inventory',
    'align-right',
    'italic',
    'allergies',
    'jack-o-lantern',
    'ambulance',
    'jedi',
    'american-sign-language-interpreting',
    'joint',
    'analytics',
    'journal-whills',
    'anchor',
    'kaaba',
    'angle-double-down',
    'key',
    'angle-double-left',
    'keyboard',
    'angle-double-right',
    'keynote',
    'angle-double-up',
    'khanda',
    'angle-down',
    'kidneys',
    'angle-left',
    'kiss-beam',
    'angle-right',
    'kiss-wink-heart',
    'angle-up',
    'kiss',
    'angry',
    'kiwi-bird',
    'ankh',
    'lambda',
    'apple-alt',
    'lamp',
    'archive',
    'landmark',
    'archway',
    'language',
    'arrow-alt-circle-down',
    'laptop-code',
    'arrow-alt-circle-left',
    'laptop',
    'arrow-alt-circle-right',
    'laugh-beam',
    'arrow-alt-circle-up',
    'laugh-squint',
    'arrow-alt-down',
    'laugh-wink',
    'arrow-alt-from-bottom',
    'laugh',
    'arrow-alt-from-left',
    'layer-group',
    'arrow-alt-from-right',
    'layer-minus',
    'arrow-alt-from-top',
    'layer-plus',
    'arrow-alt-left',
    'leaf-heart',
    'arrow-alt-right',
    'leaf',
    'arrow-alt-square-down',
    'lemon',
    'arrow-alt-square-left',
    'less-than-equal',
    'arrow-alt-square-right',
    'less-than',
    'arrow-alt-square-up',
    'level-down-alt',
    'arrow-alt-to-bottom',
    'level-down',
    'arrow-alt-to-left',
    'level-up-alt',
    'arrow-alt-to-right',
    'level-up',
    'arrow-alt-to-top',
    'life-ring',
    'arrow-alt-up',
    'lightbulb-dollar',
    'arrow-circle-down',
    'lightbulb-exclamation',
    'arrow-circle-left',
    'lightbulb-on',
    'arrow-circle-right',
    'lightbulb-slash',
    'arrow-circle-up',
    'lightbulb',
    'arrow-down',
    'link',
    'arrow-from-bottom',
    'lips',
    'arrow-from-left',
    'lira-sign',
    'arrow-from-right',
    'list-alt',
    'arrow-from-top',
    'list-ol',
    'arrow-left',
    'list-ul',
    'arrow-right',
    'list',
    'arrow-square-down',
    'location-arrow',
    'arrow-square-left',
    'location-circle',
    'arrow-square-right',
    'location-slash',
    'arrow-square-up',
    'location',
    'arrow-to-bottom',
    'lock-alt',
    'arrow-to-left',
    'lock-open-alt',
    'arrow-to-right',
    'lock-open',
    'arrow-to-top',
    'lock',
    'arrow-up',
    'long-arrow-alt-down',
    'arrows-alt-h',
    'long-arrow-alt-left',
    'arrows-alt-v',
    'long-arrow-alt-right',
    'arrows-alt',
    'long-arrow-alt-up',
    'arrows-h',
    'long-arrow-down',
    'arrows-v',
    'long-arrow-left',
    'arrows',
    'long-arrow-right',
    'assistive-listening-systems',
    'long-arrow-up',
    'asterisk',
    'loveseat',
    'at',
    'low-vision',
    'atlas',
    'luchador',
    'atom-alt',
    'luggage-cart',
    'atom',
    'lungs',
    'audio-description',
    'magic',
    'award',
    'magnet',
    'backpack',
    'mail-bulk',
    'backspace',
    'male',
    'backward',
    'map-marked-alt',
    'badge-check',
    'map-marked',
    'badge-dollar',
    'map-marker-alt-slash',
    'badge-percent',
    'map-marker-alt',
    'badge',
    'map-marker-check',
    'balance-scale-left',
    'map-marker-edit',
    'balance-scale-right',
    'map-marker-exclamation',
    'balance-scale',
    'map-marker-minus',
    'ban',
    'map-marker-plus',
    'band-aid',
    'map-marker-question',
    'barcode-alt',
    'map-marker-slash',
    'barcode-read',
    'map-marker-smile',
    'barcode-scan',
    'map-marker-times',
    'barcode',
    'map-marker',
    'bars',
    'map-pin',
    'baseball-ball',
    'map-signs',
    'baseball',
    'map',
    'basketball-ball',
    'marker',
    'basketball-hoop',
    'mars-double',
    'bath',
    'mars-stroke-h',
    'battery-bolt',
    'mars-stroke-v',
    'battery-empty',
    'mars-stroke',
    'battery-full',
    'mars',
    'battery-half',
    'medal',
    'battery-quarter',
    'medkit',
    'battery-slash',
    'megaphone',
    'battery-three-quarters',
    'meh-blank',
    'bed',
    'meh-rolling-eyes',
    'beer',
    'meh',
    'bell-school-slash',
    'memory',
    'bell-school',
    'menorah',
    'bell-slash',
    'mercury',
    'bell',
    'microchip',
    'bezier-curve',
    'microphone-alt-slash',
    'bible',
    'microphone-alt',
    'bicycle',
    'microphone-slash',
    'binoculars',
    'microphone',
    'birthday-cake',
    'microscope',
    'blanket',
    'mind-share',
    'blender',
    'minus-circle',
    'blind',
    'minus-hexagon',
    'bold',
    'minus-octagon',
    'bolt',
    'minus-square',
    'bomb',
    'minus',
    'bone-break',
    'mobile-alt',
    'bone',
    'mobile-android-alt',
    'bong',
    'mobile-android',
    'book-alt',
    'mobile',
    'book-heart',
    'money-bill-alt',
    'book-open',
    'money-bill-wave-alt',
    'book-reader',
    'money-bill-wave',
    'book',
    'money-bill',
    'bookmark',
    'money-check-alt',
    'books',
    'money-check',
    'bowling-ball',
    'monitor-heart-rate',
    'bowling-pins',
    'monument',
    'box-alt',
    'moon',
    'box-check',
    'mortar-pestle',
    'box-fragile',
    'mosque',
    'box-full',
    'motorcycle',
    'box-heart',
    'mouse-pointer',
    'box-open',
    'music',
    'box-up',
    'neuter',
    'box-usd',
    'newspaper',
    'box',
    'not-equal',
    'boxes-alt',
    'notes-medical',
    'boxes',
    'object-group',
    'boxing-glove',
    'object-ungroup',
    'braille',
    'octagon',
    'brain',
    'oil-can',
    'briefcase-medical',
    'oil-temp',
    'briefcase',
    'om',
    'broadcast-tower',
    'omega',
    'broom',
    'outdent',
    'browser',
    'paint-brush-alt',
    'brush',
    'paint-brush',
    'bug',
    'paint-roller',
    'building',
    'palette',
    'bullhorn',
    'pallet-alt',
    'bullseye-arrow',
    'pallet',
    'bullseye-pointer',
    'paper-plane',
    'bullseye',
    'paperclip',
    'burn',
    'parachute-box',
    'bus-alt',
    'paragraph',
    'bus-school',
    'parking-circle-slash',
    'bus',
    'parking-circle',
    'business-time',
    'parking-slash',
    'cabinet-filing',
    'parking',
    'calculator-alt',
    'passport',
    'calculator',
    'pastafarianism',
    'calendar-alt',
    'paste',
    'calendar-check',
    'pause-circle',
    'calendar-edit',
    'pause',
    'calendar-exclamation',
    'paw',
    'calendar-minus',
    'peace',
    'calendar-plus',
    'pen-alt',
    'calendar-times',
    'pen-fancy',
    'calendar',
    'pen-nib',
    'camera-alt',
    'pen-square',
    'camera-retro',
    'pen',
    'camera',
    'pencil-alt',
    'cannabis',
    'pencil-paintbrush',
    'capsules',
    'pencil-ruler',
    'car-alt',
    'pencil',
    'car-battery',
    'pennant',
    'car-bump',
    'people-carry',
    'car-crash',
    'percent',
    'car-garage',
    'percentage',
    'car-mechanic',
    'person-carry',
    'car-side',
    'person-dolly-empty',
    'car-tilt',
    'person-dolly',
    'car-wash',
    'phone-office',
    'car',
    'phone-plus',
    'caret-circle-down',
    'phone-slash',
    'caret-circle-left',
    'phone-square',
    'caret-circle-right',
    'phone-volume',
    'caret-circle-up',
    'phone',
    'caret-down',
    'pi',
    'caret-left',
    'piggy-bank',
    'caret-right',
    'pills',
    'caret-square-down',
    'place-of-worship',
    'caret-square-left',
    'plane-alt',
    'caret-square-right',
    'plane-arrival',
    'caret-square-up',
    'plane-departure',
    'caret-up',
    'plane',
    'cart-arrow-down',
    'play-circle',
    'cart-plus',
    'play',
    'certificate',
    'plug',
    'chalkboard-teacher',
    'plus-circle',
    'chalkboard',
    'plus-hexagon',
    'charging-station',
    'plus-octagon',
    'chart-area',
    'plus-square',
    'chart-bar',
    'plus',
    'chart-line-down',
    'podcast',
    'chart-line',
    'podium',
    'chart-pie-alt',
    'poll-h',
    'chart-pie',
    'poll',
    'check-circle',
    'poo',
    'check-double',
    'poop',
    'check-square',
    'portrait',
    'check',
    'pound-sign',
    'chess-bishop-alt',
    'power-off',
    'chess-bishop',
    'pray',
    'chess-board',
    'praying-hands',
    'chess-clock-alt',
    'prescription-bottle-alt',
    'chess-clock',
    'prescription-bottle',
    'chess-king-alt',
    'prescription',
    'chess-king',
    'presentation',
    'chess-knight-alt',
    'print-slash',
    'chess-knight',
    'print',
    'chess-pawn-alt',
    'procedures',
    'chess-pawn',
    'project-diagram',
    'chess-queen-alt',
    'puzzle-piece',
    'chess-queen',
    'qrcode',
    'chess-rook-alt',
    'question-circle',
    'chess-rook',
    'question-square',
    'chess',
    'question',
    'chevron-circle-down',
    'quidditch',
    'chevron-circle-left',
    'quote-left',
    'chevron-circle-right',
    'quote-right',
    'chevron-circle-up',
    'quran',
    'chevron-double-down',
    'racquet',
    'chevron-double-left',
    'ramp-loading',
    'chevron-double-right',
    'random',
    'chevron-double-up',
    'receipt',
    'chevron-down',
    'rectangle-landscape',
    'chevron-left',
    'rectangle-portrait',
    'chevron-right',
    'rectangle-wide',
    'chevron-square-down',
    'recycle',
    'chevron-square-left',
    'redo-alt',
    'chevron-square-right',
    'redo',
    'chevron-square-up',
    'registered',
    'chevron-up',
    'repeat-1-alt',
    'child',
    'repeat-1',
    'church',
    'repeat-alt',
    'circle-notch',
    'repeat',
    'circle',
    'reply-all',
    'city',
    'reply',
    'clipboard-check',
    'retweet-alt',
    'clipboard-list',
    'retweet',
    'clipboard-prescription',
    'ribbon',
    'clipboard',
    'road',
    'clock',
    'robot',
    'clone',
    'rocket',
    'closed-captioning',
    'route-highway',
    'cloud-download-alt',
    'route-interstate',
    'cloud-download',
    'route',
    'cloud-upload-alt',
    'rss-square',
    'cloud-upload',
    'rss',
    'cloud',
    'ruble-sign',
    'club',
    'ruler-combined',
    'cocktail',
    'ruler-horizontal',
    'code-branch',
    'ruler-triangle',
    'code-commit',
    'ruler-vertical',
    'code-merge',
    'ruler',
    'code',
    'rupee-sign',
    'coffee',
    'sad-cry',
    'cog',
    'sad-tear',
    'cogs',
    'save',
    'coins',
    'scalpel-path',
    'columns',
    'scalpel',
    'comment-alt-check',
    'scanner-keyboard',
    'comment-alt-dollar',
    'scanner-touchscreen',
    'comment-alt-dots',
    'scanner',
    'comment-alt-edit',
    'school',
    'comment-alt-exclamation',
    'screwdriver',
    'comment-alt-lines',
    'scrubber',
    'comment-alt-minus',
    'search-dollar',
    'comment-alt-plus',
    'search-location',
    'comment-alt-slash',
    'search-minus',
    'comment-alt-smile',
    'search-plus',
    'comment-alt-times',
    'search',
    'comment-alt',
    'seedling',
    'comment-check',
    'server',
    'comment-dollar',
    'shapes',
    'comment-dots',
    'share-all',
    'comment-edit',
    'share-alt-square',
    'comment-exclamation',
    'share-alt',
    'comment-lines',
    'share-square',
    'comment-minus',
    'share',
    'comment-plus',
    'shekel-sign',
    'comment-slash',
    'shield-alt',
    'comment-smile',
    'shield-check',
    'comment-times',
    'shield',
    'comment',
    'ship',
    'comments-alt-dollar',
    'shipping-fast',
    'comments-alt',
    'shipping-timed',
    'comments-dollar',
    'shoe-prints',
    'comments',
    'shopping-bag',
    'compact-disc',
    'shopping-basket',
    'compass-slash',
    'shopping-cart',
    'compass',
    'shower',
    'compress-alt',
    'shredder',
    'compress-wide',
    'shuttle-van',
    'compress',
    'shuttlecock',
    'concierge-bell',
    'sigma',
    'container-storage',
    'sign-in-alt',
    'conveyor-belt-alt',
    'sign-in',
    'conveyor-belt',
    'sign-language',
    'cookie-bite',
    'sign-out-alt',
    'cookie',
    'sign-out',
    'copy',
    'sign',
    'copyright',
    'signal-1',
    'couch',
    'signal-2',
    'credit-card-blank',
    'signal-3',
    'credit-card-front',
    'signal-4',
    'credit-card',
    'signal-alt-1',
    'cricket',
    'signal-alt-2',
    'crop-alt',
    'signal-alt-3',
    'crop',
    'signal-alt-slash',
    'cross',
    'signal-alt',
    'crosshairs',
    'signal-slash',
    'crow',
    'signal',
    'crown',
    'signature',
    'cube',
    'sitemap',
    'cubes',
    'skeleton',
    'curling',
    'skull',
    'cut',
    'sliders-h-square',
    'database',
    'sliders-h',
    'deaf',
    'sliders-v-square',
    'desktop-alt',
    'sliders-v',
    'desktop',
    'smile-beam',
    'dharmachakra',
    'smile-plus',
    'diagnoses',
    'smile-wink',
    'diamond',
    'smile',
    'dice-five',
    'smoking-ban',
    'dice-four',
    'smoking',
    'dice-one',
    'snowflake',
    'dice-six',
    'socks',
    'dice-three',
    'solar-panel',
    'dice-two',
    'sort-alpha-down',
    'dice',
    'sort-alpha-up',
    'digital-tachograph',
    'sort-amount-down',
    'diploma',
    'sort-amount-up',
    'directions',
    'sort-down',
    'divide',
    'sort-numeric-down',
    'dizzy',
    'sort-numeric-up',
    'dna',
    'sort-up',
    'do-not-enter',
    'sort',
    'dollar-sign',
    'spa',
    'dolly-empty',
    'space-shuttle',
    'dolly-flatbed-alt',
    'spade',
    'dolly-flatbed-empty',
    'spinner-third',
    'dolly-flatbed',
    'spinner',
    'dolly',
    'splotch',
    'donate',
    'spray-can',
    'door-closed',
    'square-full',
    'door-open',
    'square-root-alt',
    'dot-circle',
    'square-root',
    'dove',
    'square',
    'download',
    'stamp',
    'drafting-compass',
    'star-and-crescent',
    'draw-circle',
    'star-exclamation',
    'draw-polygon',
    'star-half-alt',
    'draw-square',
    'star-half',
    'drum-steelpan',
    'star-of-david',
    'drum',
    'star-of-life',
    'dumbbell',
    'star',
    'ear',
    'steering-wheel',
    'edit',
    'step-backward',
    'eject',
    'step-forward',
    'ellipsis-h-alt',
    'stethoscope',
    'ellipsis-h',
    'sticky-note',
    'ellipsis-v-alt',
    'stomach',
    'ellipsis-v',
    'stop-circle',
    'empty-set',
    'stop',
    'engine-warning',
    'stopwatch',
    'envelope-open-dollar',
    'store-alt',
    'envelope-open-text',
    'store',
    'envelope-open',
    'stream',
    'envelope-square',
    'street-view',
    'envelope',
    'strikethrough',
    'equals',
    'stroopwafel',
    'eraser',
    'subscript',
    'euro-sign',
    'subway',
    'exchange-alt',
    'suitcase-rolling',
    'exchange',
    'suitcase',
    'exclamation-circle',
    'sun',
    'exclamation-square',
    'superscript',
    'exclamation-triangle',
    'surprise',
    'exclamation',
    'swatchbook',
    'expand-alt',
    'swimmer',
    'expand-arrows-alt',
    'swimming-pool',
    'expand-arrows',
    'synagogue',
    'expand-wide',
    'sync-alt',
    'expand',
    'sync',
    'external-link-alt',
    'syringe',
    'external-link-square-alt',
    'table-tennis',
    'external-link-square',
    'table',
    'external-link',
    'tablet-alt',
    'eye-dropper',
    'tablet-android-alt',
    'eye-slash',
    'tablet-android',
    'eye',
    'tablet-rugged',
    'fast-backward',
    'tablet',
    'fast-forward',
    'tablets',
    'fax',
    'tachometer-alt-average',
    'feather-alt',
    'tachometer-alt-fast',
    'feather',
    'tachometer-alt-fastest',
    'female',
    'tachometer-alt-slow',
    'field-hockey',
    'tachometer-alt-slowest',
    'fighter-jet',
    'tachometer-alt',
    'file-alt',
    'tachometer-average',
    'file-archive',
    'tachometer-fast',
    'file-audio',
    'tachometer-fastest',
    'file-certificate',
    'tachometer-slow',
    'file-chart-line',
    'tachometer-slowest',
    'file-chart-pie',
    'tachometer',
    'file-check',
    'tag',
    'file-code',
    'tags',
    'file-contract',
    'tally',
    'file-download',
    'tape',
    'file-edit',
    'tasks',
    'file-excel',
    'taxi',
    'file-exclamation',
    'teeth-open',
    'file-export',
    'teeth',
    'file-image',
    'tennis-ball',
    'file-import',
    'terminal',
    'file-invoice-dollar',
    'text-height',
    'file-invoice',
    'text-width',
    'file-medical-alt',
    'th-large',
    'file-medical',
    'th-list',
    'file-minus',
    'th',
    'file-pdf',
    'theater-masks',
    'file-plus',
    'thermometer-empty',
    'file-powerpoint',
    'thermometer-full',
    'file-prescription',
    'thermometer-half',
    'file-signature',
    'thermometer-quarter',
    'file-spreadsheet',
    'thermometer-three-quarters',
    'file-times',
    'thermometer',
    'file-upload',
    'theta',
    'file-user',
    'thumbs-down',
    'file-video',
    'thumbs-up',
    'file-word',
    'thumbtack',
    'file',
    'ticket-alt',
    'fill-drip',
    'ticket',
    'fill',
    'tilde',
    'film-alt',
    'times-circle',
    'film',
    'times-hexagon',
    'filter',
    'times-octagon',
    'fingerprint',
    'times-square',
    'fire-extinguisher',
    'times',
    'fire',
    'tint-slash',
    'first-aid',
    'tint',
    'fish',
    'tire-flat',
    'flag-checkered',
    'tire-pressure-warning',
    'flag',
    'tire-rugged',
    'flask',
    'tire',
    'flushed',
    'tired',
    'folder-minus',
    'toggle-off',
    'folder-open',
    'toggle-on',
    'folder-plus',
    'toolbox',
    'folder-times',
    'tooth',
    'folder',
    'toothbrush',
    'folders',
    'torah',
    'font-awesome-logo-full',
    'torii-gate',
    'font',
    'trademark',
    'football-ball',
    'traffic-cone',
    'football-helmet',
    'traffic-light-go',
    'forklift',
    'traffic-light-slow',
    'forward',
    'traffic-light-stop',
    'fragile',
    'traffic-light',
    'frog',
    'train',
    'frown-open',
    'transgender-alt',
    'frown',
    'transgender',
    'function',
    'trash-alt',
    'funnel-dollar',
    'trash',
    'futbol',
    'tree-alt',
    'gamepad',
    'tree',
    'gas-pump-slash',
    'triangle',
    'gas-pump',
    'trophy-alt',
    'gavel',
    'trophy',
    'gem',
    'truck-container',
    'genderless',
    'truck-couch',
    'gift-card',
    'truck-loading',
    'gift',
    'truck-monster',
    'glass-martini-alt',
    'truck-moving',
    'glass-martini',
    'truck-pickup',
    'glasses-alt',
    'truck-ramp',
    'glasses',
    'truck',
    'globe-africa',
    'tshirt',
    'globe-americas',
    'tty',
    'globe-asia',
    'tv-retro',
    'globe-stand',
    'tv',
    'globe',
    'umbrella-beach',
    'golf-ball',
    'umbrella',
    'golf-club',
    'underline',
    'gopuram',
    'undo-alt',
    'graduation-cap',
    'undo',
    'greater-than-equal',
    'union',
    'greater-than',
    'universal-access',
    'grimace',
    'university',
    'grin-alt',
    'unlink',
    'grin-beam-sweat',
    'unlock-alt',
    'grin-beam',
    'unlock',
    'grin-hearts',
    'upload',
    'grin-squint-tears',
    'usd-circle',
    'grin-squint',
    'usd-square',
    'grin-stars',
    'user-alt-slash',
    'grin-tears',
    'user-alt',
    'grin-tongue-squint',
    'user-astronaut',
    'grin-tongue-wink',
    'user-chart',
    'grin-tongue',
    'user-check',
    'grin-wink',
    'user-circle',
    'grin',
    'user-clock',
    'grip-horizontal',
    'user-cog',
    'grip-vertical',
    'user-crown',
    'h-square',
    'user-edit',
    'h1',
    'user-friends',
    'h2',
    'user-graduate',
    'h3',
    'user-lock',
    'hamsa',
    'user-md',
    'hand-heart',
    'user-minus',
    'hand-holding-box',
    'user-ninja',
    'hand-holding-heart',
    'user-plus',
    'hand-holding-seedling',
    'user-secret',
    'hand-holding-usd',
    'user-shield',
    'hand-holding-water',
    'user-slash',
    'hand-holding',
    'user-tag',
    'hand-lizard',
    'user-tie',
    'hand-paper',
    'user-times',
    'hand-peace',
    'user',
    'hand-point-down',
    'users-class',
    'hand-point-left',
    'users-cog',
    'hand-point-right',
    'users-crown',
    'hand-point-up',
    'users',
    'hand-pointer',
    'utensil-fork',
    'hand-receiving',
    'utensil-knife',
    'hand-rock',
    'utensil-spoon',
    'hand-scissors',
    'utensils-alt',
    'hand-spock',
    'utensils',
    'hands-heart',
    'value-absolute',
    'hands-helping',
    'vector-square',
    'hands-usd',
    'venus-double',
    'hands',
    'venus-mars',
    'handshake-alt',
    'venus',
    'handshake',
    'vial',
    'hashtag',
    'vials',
    'haykal',
    'video-plus',
    'hdd',
    'video-slash',
    'heading',
    'video',
    'headphones-alt',
    'vihara',
    'headphones',
    'volleyball-ball',
    'headset',
    'volume-down',
    'heart-circle',
    'volume-mute',
    'heart-rate',
    'volume-off',
    'heart-square',
    'volume-slash',
    'heart',
    'volume-up',
    'heartbeat',
    'volume',
    'helicopter',
    'walking',
    'hexagon',
    'wallet',
    'highlighter',
    'warehouse-alt',
    'history',
    'warehouse',
    'hockey-puck',
    'watch-fitness',
    'hockey-sticks',
    'watch',
    'home-heart',
    'weight-hanging',
    'home',
    'weight',
    'hospital-alt',
    'wheelchair',
    'hospital-symbol',
    'whistle',
    'hospital',
    'wifi-1',
    'hot-tub',
    'wifi-2',
    'hotel',
    'wifi-slash',
    'hourglass-end',
    'wifi',
    'hourglass-half',
    'window-alt',
    'hourglass-start',
    'window-close',
    'hourglass',
    'window-maximize',
    'i-cursor',
    'window-minimize',
    'id-badge',
    'window-restore',
    'id-card-alt',
    'window',
    'id-card',
    'wine-glass-alt',
    'image',
    'wine-glass',
    'images',
    'won-sign',
    'inbox-in',
    'wrench',
    'inbox-out',
    'x-ray',
    'inbox',
    'yen-sign',
    'indent',
    'yin-yang'
]
